export default {
  'menu.system': 'সিস্টেম ব্যবস্থাপনা',
  'menu.system.user': 'ব্যবহারকারী ব্যবস্থাপনা',
  'menu.system.role': 'ভূমিকা ব্যবস্থাপনা',
  'menu.system.menu': 'মেনু ব্যবস্থাপনা',
  'menu.system.dept': 'বিভাগ ব্যবস্থাপনা',
  'menu.monitor': 'পর্যবেক্ষণ',
  'menu.monitor.login-log': 'লগইন লগ',
  'menu.monitor.oper-log': 'অপারেশন লগ',
  'menu.login': 'লগইন',
};
